module.exports = __webpack_public_path__ + "static/33import-2a248c0c3696cc9323e8fa3ac79aa20e.png";